import { useState } from "react";

export const faqItems = [
  {
    question: "爆料看点上的话题内容是从哪里来的？",
    answer:
      "话题线索主要来自网友投递与公开讨论，编辑会先核对时间、地点与当事人回应，再把事件梳理成可阅读的段落。同一个话题会同时收录支持方与反对方的观点，不做单方面摘录。",
  },
  {
    question: "评论区的高能回复、神评是怎么被选出来的？",
    answer:
      "我们优先挑选被大量引用、补充了新信息，或者论证逻辑完整的回复。标记为神评的通常是传播度最高的那条，标记为高能的偏重信息量，热评则代表当下讨论温度最高。标记只是整理方式，不代表我们认同其中的观点。",
  },
  {
    question: "投票结果能代表大多数人的想法吗？",
    answer:
      "不能。投票反映的是参与者的选择，参与人数、话题曝光度都会影响结果。所以在每个话题里，我们都会单独展示支持、中立、反对的三段分布，而不是只突出占比最高的那一项。",
  },
  {
    question: "一个话题会持续更新吗？",
    answer:
      "会。当事方回应、规则调整或者出现新的现场材料时，我们会在原话题下补充后续，并更新投票的截止时间。已经结束的投票会保留结果，方便回顾当时的舆论态度分布。",
  },
  {
    question: "如果我发现话题里有事实错误，怎么反馈？",
    answer:
      "把话题标题、错误位置和可核实的材料一起发到 baoliao@example.com 即可。涉及事实偏差的内容我们会优先处理，确认后会在话题内标注更正说明。",
  },
  {
    question: "可以在爆料看点投放内容或做合作吗？",
    answer:
      "目前只接受与话题内容相关的线索补充和更正请求，不接受以影响结论为目的的内容合作。任何试图干预投票结果或评论排序的请求，我们都会拒绝。",
  },
];

export default function AboutFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" aria-label="常见问题" className="scroll-mt-24">
      <div className="mb-6 flex items-center gap-2">
        <span className="h-3 w-3 rounded-sm bg-primary-500" aria-hidden="true" />
        <span className="font-label text-xs tracking-[0.2em] text-primary-700 uppercase">
          常见问题
        </span>
      </div>
      <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        关于内容与投票的六个问题
      </h2>

      <div className="mt-6 divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
        {faqItems.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div key={item.question}>
              <h3>
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                >
                  <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                    {item.question}
                  </span>
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true" />
                  </span>
                </button>
              </h3>
              {isOpen && (
                <div className="px-5 pb-5">
                  <p className="text-sm leading-loose text-foreground-700">{item.answer}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}